import _ from "lodash";
import React, { useState } from "react";
import { Modal, Button, TextInput } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import classes from "./TemplateRenameModal.scss";
const TemplateRenameModal = ({ name, closeModal, onUpdateName }) => {
  const { t } = useI18n();
  const [templateName, setTemplateName] = useState(name);

  const handleNameInput = e => {
    setTemplateName(e?.target?.value);
  };
  const handleUpdateName = () => {
    onUpdateName(templateName.trim());
  };

  return (
    <Modal
      dsVersion={"2.0"}
      hasOverlay
      onClose={closeModal}
      width={"480px"}
      height="fit-content"
    >
      <Modal.Header>
        <h4>{t("workbook:rename_template")}</h4>
      </Modal.Header>
      <Modal.Body>
        <div>
          <TextInput
            dsVersion={"2.0"}
            size="large"
            label={t("workbook:template_name")}
            value={templateName}
            placeholder={t("workbook:enter_template_name")}
            onChange={handleNameInput}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.buttonContianer}>
          <Button
            dsVersion={"2.0"}
            size="medium"
            variant={"neutral"}
            type={"outlined"}
            onClick={closeModal}
          >
            {t("common:cancel")}
          </Button>
          <Button
            dsVersion={"2.0"}
            size="medium"
            variant={"progressive"}
            type={"fill"}
            onClick={handleUpdateName}
            disabled={_.isEmpty(templateName.trim())}
          >
            {t("common:done")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default TemplateRenameModal;
